import { Formation } from "../types"

export const pos66vonalszoros: Formation = {
  id: "pos66vonalszoros",
  name: "Line press",
  category: "6 - 6",
  snapshots: [
    {
      players: [
        {
          x: 6.944945450467164,
          y: 7.5307697400967
        },
        {
          x: 3.6489610204844776,
          y: 6.244155154575727
        },
        {
          x: 12.757234051520964,
          y: 8.990589684198122
        },
        {
          x: 13.191101110679417,
          y: 3.2130060594711396
        },
        {
          x: 6.689327627384819,
          y: 3.591533337300254
        },
        {
          x: 0.6969668662961096,
          y: 3.225679130964382
        }
      ],
      opponents: [
        {
          x: 7.984326361470467,
          y: 7.55874272828461
        },
        {
          x: 4.607409934131618,
          y: 6.730573683799096
        },
        {
          x: 1.6288085901039333,
          y: 3.8675510493088225
        },
        {
          x: 7.623530598666648,
          y: 4.142199553896449
        },
        {
          x: 12.205333750735047,
          y: 3.8443166716836545
        },
        {
          x: 11.43691334787093,
          y: 8.204442105128061
        }
      ],
      ball: {
        x: 12.35539894605338,
        y: 8.809543769134558
      },
      goalkeepers: [
        {
          x: 7.048129702696806,
          y: 0.9655410237921894
        }
      ]
    }
  ]
}
